import "./WelcomeScreenBackground.scss";

import clsx from "clsx";

import { FCC } from "@/types";

interface Props {
  className?: string;
}

export const WelcomeScreenBackground: FCC<Props> = ({
  children,
  className,
}) => {
  return (
    <main
      className={clsx(
        "relative min-h-screen w-screen overflow-clip",
        className,
      )}
    >
      {/* Background image, repeated */}
      <div className="background-image absolute inset-0" />
      <div className="absolute top-0 h-[12%] w-full bg-white sm:h-[10%] md:inset-0 md:h-full md:w-[25%]">
        <div className="absolute bottom-0 h-[200px] w-full translate-y-[99%] md:right-0 md:h-full md:w-[200px] md:translate-x-[99%] md:translate-y-0">
          {/* The wave, which is added to the left side on top of the background image, to create a wave effect */}
          <svg
            className="rotate-90 md:h-full md:rotate-0"
            viewBox="60 0 100 100"
            preserveAspectRatio="none"
            fill="white"
          >
            <path d="M97 0S84 12 91 33C95 44 79 58 76 73S81 100 82 100L0 100V0H95Z" />
          </svg>
        </div>
      </div>

      <div className="relative z-10">{children}</div>
    </main>
  );
};
